export default function ({ url, title }) {

    let w = 800;
    let h = 650;
    const dualScreenLeft = window.screenLeft ?? window.screenX;
    const dualScreenTop = window.screenTop ?? window.screenY;
    const width = window.innerWidth ?? document.documentElement.clientWidth;
    const height = window.innerHeight ?? document.documentElement.clientHeight;
    const left = dualScreenLeft + (width - w) / 2;
    const top = dualScreenTop + (height - h) / 2;
    window.open(
        `${url}&user_question=${title}`,
        '_blank',
        `width=${w},height=${h},left=${left},top=${top},resizable=no`
    );
}